import { ref } from 'vue'

export const emptyPlaceholder = ref('-- --')

export const clientTypes = {
  PF: 'PF',
  PJ: 'PJ'
}

export const operationTypes = {
  BUYING: 'BUYING',
  SELLING: 'SELLING'
}

export const transactionTypes = {
  TRANSFERBUY: 'TRANSFERBUY',
  TRADEBUY: 'TRADEBUY',
  TRADESELL: 'TRADESELL',
  TRANSFERSELL: 'TRANSFERSELL'
}

export const liquidationTypeOptions = ref([
  { key: 'D0', name: 'D+0' },
  { key: 'D1', name: 'D+1' },
  { key: 'D2', name: 'D+2' }
])

export const maritalStatusOptions = ref([
  {
    name: 'Casado(a)',
    key: 'MARRIED',
    docusign: 'casado'
  },
  {
    name: 'Solteiro(a)',
    key: 'SINGLE',
    docusign: 'solteiro'
  },
  {
    name: 'Viúvo(a)',
    key: 'WIDOWED',
    docusign: 'viuvo'
  },
  {
    name: 'Divorciado(a)',
    key: 'DIVORCED',
    docusign: 'divorciado'
  },
  {
    name: 'União estável',
    key: 'STABLE_UNION',
    docusign: 'uniao_estavel'
  }
])

export const operationNatureTypes = {
  EXPMERC: 'EXPMERC'
}

export const spreadTypes = {
  PERCENTAGE: 'PERCENTAGE',
  MONETARY: 'MONETARY'
}

export const theme = {
  DARK: 'dark',
  LIGHT: 'light'
}

export const PRE_STATUS = Object.freeze({
  ALLOW: 'ALLOW',
  UNDER_ANALYSIS: 'UNDER_ANALYSIS',
  EDITING: 'EDITING',
  OUTSTANDING_DOCUMENTS: 'OUTSTANDING_DOCUMENTS',
  RECEIVED: 'RECEIVED',
  WAITING_RECEIVEMENT: 'WAITING_RECEIVEMENT',
  ORDER: 'ORDER',
  POS: 'POS'
})

export const PRE_OP_LOCKED_STATUS = new Set([PRE_STATUS.POS, PRE_STATUS.ORDER])

export const preStatusOptions = Object.freeze([
  { key: PRE_STATUS.ALLOW, name: 'Liberado' },
  { key: PRE_STATUS.UNDER_ANALYSIS, name: 'Em Análise' },
  { key: PRE_STATUS.EDITING, name: 'Em Edição' },
  { key: PRE_STATUS.OUTSTANDING_DOCUMENTS, name: 'Esperando Documentação' },
  { key: PRE_STATUS.RECEIVED, name: 'Recebimento' },
  { key: PRE_STATUS.WAITING_RECEIVEMENT, name: 'Aguardando Recebimento do Exterior' },
  { key: PRE_STATUS.ORDER, name: 'Pré-operação em taxa alvo' },
  { key: PRE_STATUS.POS, name: 'Pré-operação fechada' }
])

export const posStatusOptions = ref([
  { key: 'OPEN', name: 'Aberto' },
  { key: 'CLOSE', name: 'Finalizado' }
])

export const taxesStatusOptions = ref([
  { key: 'OPEN', name: 'Aberto' },
  { key: 'CLOSED', name: 'Fechado' },
  { key: 'CANCELED', name: 'Cancelado' }
])

export const orderOptions = ref([
  { key: 'NAME', name: 'Nome' },
  { key: 'LAST_UPDATE', name: 'Edição' },
  { key: 'LAST_CLOSED_OPERATION', name: 'Último fechamento' }
])

export const clientTypesOptions = ref([
  { key: '', name: 'Todos' },
  { key: 'PF', name: 'PF' },
  { key: 'PJ', name: 'PJ' }
])

export const typesPromoCodeOptions = ref([
  { key: 'PF', name: 'PF' },
  { key: 'PJ', name: 'PJ' },
  { key: 'PJ_PF', name: 'PF & PJ' }
])

export const CLIENT_STATUS = Object.freeze({
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  WAITING_DOCS: 'WAITING_DOCS',
  WAITING_APPROVED: 'WAITING_APPROVED'
})

export const clientStatusOptions = [
  { key: CLIENT_STATUS.PENDING, name: 'Pendente' },
  { key: CLIENT_STATUS.APPROVED, name: 'Aprovado' },
  { key: CLIENT_STATUS.WAITING_DOCS, name: 'Aguardando Documentos' },
  { key: CLIENT_STATUS.WAITING_APPROVED, name: 'Aguardando Aprovação' }
]

export const spreadTypeOptions = ref([
  { key: 'PERCENTAGE', name: 'Percentual (%)' },
  { key: 'MONETARY', name: 'Monetário (R$)' }
])

export const legalNatureOptions = ref([
  { key: 'MEI', name: 'MEI' },
  { key: 'EI', name: 'Empresário Individual (EI)' },
  { key: 'SLU', name: 'Sociedade Limitada Unipessoal (SLU)' },
  { key: 'LTDA', name: 'Sociedade Empresária Limitada (LTDA)' },
  { key: 'Sociedade Simples', name: 'Sociedade Simples' },
  { key: 'SA', name: 'Sociedade Anônima' }
])

export const documentTypeOptions = ref([
  { key: 'RG', name: 'RG' },
  { key: 'CNH', name: 'CNH' },
  { key: 'Passport', name: 'Passaporte' }
])

export const institutionTypeOptions = ref([
  { key: 'BRAZA', name: 'BRAZA' },
  { key: 'BS2', name: 'BS2' }
])

export const genderOptions = ref([
  { key: 'm', name: 'Masculino' },
  { key: 'f', name: 'Feminino' }
])

export const docusignStatus = {
  CREATED: { name: '', color: 'yellow' },
  SENT: { name: 'E-mail enviado', color: 'yellow' },
  DELIVERED: { name: 'E-mail recebido', color: 'yellow' },
  COMPLETED: { name: 'Concluído', color: 'green' },
  DECLINED: { name: 'Recusado', color: 'red' },
  VOIDED: { name: 'Anulado', color: 'red' }
}

export const typeFile = ref([
  { key: 'OPERATION_DOCUMENT', name: 'DOCUMENTOS DA OPERAÇÃO' },
  { key: 'EXCHANGE_CONTRACT', name: 'CONTRATO DOCUSIGN' },
  { key: 'ADMIN_DARF', name: 'DARFS DA OPERAÇÃO' },
  { key: 'DI_OR_DUE', name: 'DI/DU-E' },
  { key: 'CLIENT_TRANSFER', name: 'TRANSFERÊNCIA ENVIADA PELO CLIENTE' },
  { key: 'SWIFT_TRANSFER', name: 'SWIFT CLIENTE' },
  { key: 'DARF', name: 'DARF' }
])

export const DOCUMENT_STATUS_OPTIONS = Object.freeze({
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REFUSED: 'REFUSED',
  WAITING_DOCS: 'WAITING_DOCS'
})

export const documentStatusOptionList = ref([
  { key: DOCUMENT_STATUS_OPTIONS.APPROVED, name: 'APROVADO' },
  { key: DOCUMENT_STATUS_OPTIONS.PENDING, name: 'PENDENTE' },
  { key: DOCUMENT_STATUS_OPTIONS.REFUSED, name: 'RECUSADO' },
  { key: DOCUMENT_STATUS_OPTIONS.WAITING_DOCS, name: 'AGUARDANDO DOCUMENTOS' }
])

export const CLIENT_DEMAND_TYPE = Object.freeze({
  SELLING: 'SELLING',
  BUYING: 'BUYING'
})

export const CLIENT_DEMAND_REASON = Object.freeze({
  RECEIVING_SERVICES: 'RECEIVING_SERVICES',
  RECEIVING_INVESTMENT: 'RECEIVING_INVESTMENT',
  DONATIONS: 'DONATIONS',
  RECEIVING_OTHER: 'RECEIVING_OTHER',
  SENDING_FAMILY: 'SENDING_FAMILY',
  SERVICES_PURCHASE: 'SERVICES_PURCHASE',
  INVESTMENT: 'INVESTMENT',
  SENDING_OTHER: 'SENDING_OTHER'
})

export const KYC_PURPOSE = Object.freeze({
  [CLIENT_DEMAND_REASON.RECEIVING_SERVICES]: 'Recebimento de serviços prestados',
  [CLIENT_DEMAND_REASON.RECEIVING_INVESTMENT]: 'Recebimento de investimento, lucros ou dividendos',
  [CLIENT_DEMAND_REASON.DONATIONS]: 'Doações',
  [CLIENT_DEMAND_REASON.SENDING_FAMILY]: 'Envio para familiares',
  [CLIENT_DEMAND_REASON.SERVICES_PURCHASE]: 'Compra de serviços no exterior',
  [CLIENT_DEMAND_REASON.INVESTMENT]: 'Investimento'
})

export const KYC_PURPOSE_OPTIONS = Object.freeze({
  [CLIENT_DEMAND_REASON.SENDING_FAMILY]: 'BRAZILIAN_CAPITAL',
  [CLIENT_DEMAND_REASON.SERVICES_PURCHASE]: 'MISCELLANEOUS_SERVICES',
  [CLIENT_DEMAND_REASON.INVESTMENT]: 'BRAZILIAN_CAPITAL',
  [CLIENT_DEMAND_REASON.RECEIVING_SERVICES]: 'MISCELLANEOUS_SERVICES',
  [CLIENT_DEMAND_REASON.RECEIVING_INVESTMENT]: 'FOREIGN_TRADE',
  [CLIENT_DEMAND_REASON.DONATIONS]: 'FOREIGN_CAPITAL'
})

export const kycBusinessPurposeOptions = ref([
  { key: 'FOREIGN_TRADE', name: 'Comércio Exterior' },
  { key: 'BRAZILIAN_CAPITAL', name: 'Capitais Brasileiros' },
  { key: 'FOREIGN_CAPITAL', name: 'Capitais Estrangeiros' },
  { key: 'MISCELLANEOUS_SERVICES', name: 'Serviços Diversos' },
  { key: 'INSURANCE', name: 'Seguros' },
  { key: 'NON_RESIDENT_ACCOUNT', name: 'Conta de Não Residente' }
])

export const KYC_OPERATION_LEVELS = Object.freeze({
  BELOW_50K: 'BELOW_50K',
  BETWEEN_50K_AND_100K: 'BETWEEN_50K_AND_100K',
  BETWEEN_100K_AND_500K: 'BETWEEN_100K_AND_500K',
  ABOVE_500K: 'ABOVE_500K'
})

export const kycOperationalLevelOptions = ref([
  { key: KYC_OPERATION_LEVELS.BELOW_50K, name: 'Até US$ 50.000,00' },
  { key: KYC_OPERATION_LEVELS.BETWEEN_50K_AND_100K, name: 'Entre US$ 50.000,01 e US$ 100.000,00' },
  {
    key: KYC_OPERATION_LEVELS.BETWEEN_100K_AND_500K,
    name: 'Entre US$ 100.000,01 e US$ 500.000,00'
  },
  { key: KYC_OPERATION_LEVELS.ABOVE_500K, name: 'Acima de US$ 500.000,00' }
])
